import { Injectable } from '@angular/core';
import { SQLite, SQLiteObject,DbTransaction } from '@ionic-native/sqlite/ngx';
@Injectable({
  providedIn: 'root'
})
export class SqliteServicesService {

  constructor(
    private sqlite: SQLite
  ) { }
  /**
   * 连接数据库获取连接
   */
  public Connection():Promise<SQLiteObject>{
    const that =this;
    return new Promise<SQLiteObject>((resolve,reject)=>{
      that.sqlite.create( 
        {name: 'a2.db',
         location: 'default'
        }).then((db:SQLiteObject)=>{
          console.log("打开连接");
          db.open().then(open=>{
            resolve(db);
          }).catch(err=>{
            reject(err);
            console.log(err,"打开数据库失败");
          });
        })
        .catch(berr=>{
          reject(berr);
              console.log(berr,"OK");
          });
    });
}
/**
 *  插入数据到数据库表中,所有的表都自带自增字段
 */
public Insert(sql:string="sysconfig",values:Array<any>=[]):Promise<any>{
  const that =this;
  return new Promise<any>((resolve,reject)=>{
    that.Connection().then(db=>{
      db.transaction(fn=>{
        fn.executeSql(sql,values,(success)=>{
          resolve(success);
        },error=>{
          reject(error);
        });
      }).then(data=>{
        console.log(data,"关闭数据库连接结束");
        db.close();
      }).catch(err=>{
        console.log(err,"关闭数据库连接失败");
        db.close();
      });
      });
    });
}
/**
 * 查询表数据,更具sql语句查询 默认:select * from sysconfig where name=?
 */
public Select(_tablesql:string="select * from sysconfig",values:Array<any>=[]) {
  const that =this;
  return new Promise<any>((resolve,reject)=>{
    that.Connection().then(db=>{
      console.log("打开连接2");
      db.executeSql(_tablesql,values).then(items=>{
        resolve(items);
      }).catch(error=>{
        reject(error);
      });
      });
    });
}
/**
 * 查询表数据,更具sql语句查询 默认:select * from sysconfig where name=?
 */
public SelectPageXml(_tablesql:string="select * from sysconfig",values:Array<any>=[]) {
  const that =this;
  return new Promise<any>((resolve,reject)=>{
    const xmlName:string=values[0];
    if(sessionStorage.getItem(xmlName)){
      resolve(JSON.parse(sessionStorage.getItem(xmlName)));
    }else{
      that.Connection().then(db=>{
        console.log("打开连接2");
        db.executeSql(_tablesql,values).then(data=>{
          let _temp:any={Key:null,Data:null};
          _temp["Key"]=data.rows.item(0).name;
          _temp["Data"]=JSON.parse(data.rows.item(0).content);
            sessionStorage.setItem(xmlName,JSON.stringify(_temp));
            resolve(_temp);
        }).catch(err=>{
          reject(err);
        });
          // db.transaction(fn=>{
          //   fn.executeSql(_tablesql,values,(success,items)=>{
          //         let _temp:any={Key:null,Data:null};
          //             _temp["Key"]=items.rows.item(0).name;
          //             _temp["Data"]=JSON.parse(items.rows.item(0).content);
          //               sessionStorage.setItem(xmlName,JSON.stringify(_temp));
          //               resolve(_temp);
              
          //   },(error,items)=>{
          //     reject(items);
          //   });
          // }).then(data=>{
          //   console.log(data,"关闭数据库连接结束");
          //  try{
          //   db.close();
          //  }catch(err){
          //    console.log(err,"关闭事务");
          //  }
          // }).catch(err=>{
          //   console.log(err,"关闭数据库连接失败");
          //  try{
          //   db.close();
          //  }catch(err){
          //    console.log(err,"关闭事务");
          //  }
          // });
      });
    }
  });
}
/**
 *  批量插入数据到数据库,数据格式为[{sql:"INSERT INTO sys..values(?,?,?)",values:[null,'..','...']}];
 */
public InsertItems(array:Array<any>=[]):Promise<any>{
  const that =this;
  return new Promise<any>((resolve,reject)=>{
    that.Connection().then(db=>{
      db.transaction(fn=>{
        console.log(array,"shuju");
        array.forEach((items,index)=>{
          fn.executeSql(items.sql,items.values,(success,items)=>{
              console.log("插入数据成功");
          },(error,items)=>{
            console.log(items,"插入数据失败");
          });
        });
      }).then(data=>{
        
        console.log(data,"关闭数据库连接结束");
        db.close();
        resolve(data);
      }).catch(err=>{
        console.log(err,"关闭数据库连接失败");
        db.close();
        reject(err);
      });
      });
    });
}
/**
 * 更新数据库数据的sql语句
 * @param sql 需要更新的sql语句 UPDATE sys.. SET firstname = ? WHERE acctNo = ?,...
 * @param values  需要更新的值 default [“张三”,"李四"，。。。]
 */
public update(sql:string,values:Array<any>=[]):Promise<any>{
  const that =this;
  return new Promise<any>((resolve,reject)=>{
    that.Connection().then(db=>{
      db.executeSql(sql,values).then(data=>{
        resolve(data);
      }).catch(err=>{
        reject(err);
      });
      });
    });
}
/**
 * 删除数据
 * @param sql 需要删除的sql语句 DELETE FROM sys..  WHERE acctNo = ?,...
 * @param values  需要删除的值 default [“张三”,。。。]
 */
public Delete(sql:string,values:Array<any>=[]):Promise<any>{
  const that =this;
  return new Promise<any>((resolve,reject)=>{
    that.Connection().then(db=>{
      db.transaction(fn=>{
        fn.executeSql(sql,values,(success)=>{
          resolve(success);
        },error=>{
          reject(error);
        });
      }).then(data=>{
        console.log(data,"关闭数据库连接结束");
        db.close();
      }).catch(err=>{
        console.log(err,"关闭数据库连接失败");
        db.close();
      });
      });
    });
}
/**
 * 操作数据库数据
 * @param sql 可以自定义任意操作数据库sql语句(delete  select insert update)
 * @param values  需要操作的值 default [“张三”,。。。]
 */
public Dal(sql:string,values:Array<any>=[]):Promise<any>{
  const that =this;
  return new Promise<any>((resolve,reject)=>{
    that.Connection().then(db=>{
      db.transaction(fn=>{
        fn.executeSql(sql,values,(success)=>{
          resolve(success);
        },error=>{
          reject(error);
        });
      }).then(data=>{
        console.log(data,"关闭数据库连接结束");
        db.close();
      }).catch(err=>{
        console.log(err,"关闭数据库连接失败");
        db.close();
      });
      });
    });
}
/**
 * 批量新增数据前判断是否数据重复
 * @param array 批量插入数据到数据库,数据格式为[{sql:"INSERT INTO sys..values(?,?,?)",values:[null,'..','...']}];
 */
defaultSql(array:Array<any>=[]){
  const that =this;
  return new Promise<any>((resolve,reject)=>{
    try{
      that.Connection().then(db=>{
        db.transaction(fn=>{
          console.log(array,"shuju");
          array.forEach((items,index)=>{
            let configName:any=items.values[1];
            console.log(items.values[1],"name");
            if(configName){
              fn.executeSql("select * from sysconfig where name=?",[configName],(fn,item)=>{
                if(item.rows.length<=0){
                  console.log(items,"插入不同");
                  fn.executeSql(items.sql,items.values,(success,items)=>{
                    console.log("插入数据成功");
                  },(error,items)=>{
                    console.log(items,"插入数据失败");
                  });
                }else{
                  let content:any = items.values[2];
                  fn.executeSql("update sysconfig set content=? where name=?",[content,configName],(f,item)=>{
                    console.log(item,"更新成功");
                  },(error,item)=>{
                    console.log(item,"更新成功");
                  });
                }
              },(error,err)=>{
                console.log(err,"插入错误");
              });
            }
          });
        }).then(data=>{
          
          console.log(data,"关闭数据库连接结束");
          resolve(data);
          // db.close().then(close=>{
          //   resolve(data);
          // }).catch(err=>{
          //   reject(err);
          //   console.log(err,"关闭数据库连接结束");
          // });
        }).catch(err=>{
          console.log(err,"关闭数据库连接失败");
          reject(err);
          // db.close().then(close=>{
          //   reject(err);
          // }).catch(err=>{
          //   reject(err);
          //   console.log(err,"关闭数据库连接结束");
          // });
        });
        });
    }catch(err){
      reject(err);
    }
    });
}
/**
 * 执行查询以及不不带参数的sql查询
 * @param defaultSql 需要执行的sql语句
 * @param parmas 参数
 */
CustomerSql(defaultSql:string,parmas:Array<string>=[]):Promise<any>{
  const that=this;
  return new Promise<any>((resolve,reject)=>{
    that.Connection().then(db=>{
      db.executeSql(defaultSql,parmas).then(body=>{
        resolve(body);
      }).catch(err=>{
        reject(err);
      });
    }).catch(err=>{
     console.log(err,"连接失败");
     reject(err);
    });
  });
}  
}
